const em = px => `${px / 16}em`
const mountMedia = val => `@media screen and (max-width: ${val})`

export const breakpoints = {
  mobile: em(630),
  tablet: em(920),
  desktop: em(1120),
}

export const media = {
  mobile: mountMedia(breakpoints.mobile),
  tablet: mountMedia(breakpoints.tablet),
  desktop: mountMedia(breakpoints.desktop),
}
